import assign from "object-assign";
import base from "./base";

function entity(props, constants) {
    let entityProps = {
        getInitialState() {
            return {
                current: null,
                items: {}
            };
        },
        remove(url) {
            delete this.state.items[url];
            this.hasChanged();
        },
        removeCurrent() {
            let temp = this.state.current;

            this.state.current = undefined;
            this.remove(temp);
        },
        add(item, force) {
            this.addList([item], force);
        },
        addCurrent(item) {
            this.state.current = item.url;
            this.add(item, true);
        },
        addList(items, force) {
            if (!items) {
                return;
            }

            items = Array.isArray(items) ? items : [items];

            items.forEach((item) => {
                if (item.url || force) {
                    this.state.items[item.url] = item;
                } else {
                    console.warn("The item you are trying to add does not have a url");
                }
            });
            this.hasChanged();
        }
    };

    return base(assign({}, entityProps, props), constants);
}

export default entity;



/** WEBPACK FOOTER **
 ** ./app/utils/stores/entity.js
 **/